module.exports = __webpack_public_path__ + "img/text-left-image-right.ccdc8caa.svg";